module.exports = "/assets/data/4d2d17ac8961513e24cc53eba6ca8756-MK5.data.json";